<div class="maintenance-status-section">
  <div class="maintenance-status-header">
    <h3>{{ 'maintenanceStatus' | translate }}</h3>
    <div class="maintenance-status-actions">
      <app-ui-select
        class="vessel-select"
        [label]="'departmentSelector' | translate"
        [control]="vesselControl"
        [options]="vesselOptions()"
        [isMultiple]="false"
      ></app-ui-select>
      <div class="time-period-group">
        <app-ui-select
          class="period-select"
          [label]="'timePeriod' | translate"
          [control]="periodControl"
          [options]="periodOptions"
          [isMultiple]="false"
        ></app-ui-select>
        <app-ui-date-range-picker
          [control]="customRangeControl"
          [maxDate]="maxDate"
        ></app-ui-date-range-picker>
      </div>
    </div>
  </div>
  <div
    class="maintenance-widgets-row"
    *appLoader="(loadingActions | actionInProgress: true | async) === true"
  >
    <!-- Expired jobs + Critical (dual) -->
    <app-ui-widget-card
      [blocks]="expiredJobsData"
      [clickable]="true"
      (blockClick)="onExpiredJobsBlockClick($event)"
    ></app-ui-widget-card>

    <!-- Due soon jobs + Critical (dual) -->
    <app-ui-widget-card
      [blocks]="dueSoonJobsData"
      [clickable]="true"
      (blockClick)="onDueSoonJobsBlockClick($event)"
    ></app-ui-widget-card>

    <!-- Postponed jobs (single) -->
    <app-ui-widget-card
      name="postponedJobs"
      [value]="postponedJobs"
      icon="schedule"
      iconColor="orange"
      [clickable]="false"
      [matTooltip]="'postponedJobsTooltip' | translate"
    ></app-ui-widget-card>

    <!-- In progress jobs (single) -->
    <app-ui-widget-card
      name="inProgressJobs"
      [value]="inProgressJobs"
      icon="sync"
      iconColor="cyan"
      [clickable]="true"
      [matTooltip]="'inProgressJobsTooltip' | translate"
      (click)="openInProgressJobs()"
    ></app-ui-widget-card>

    <!-- Completed jobs (single) -->
    <app-ui-widget-card
      name="completedJobs"
      [value]="completedJobs"
      description="forTimePeriod"
      icon="check"
      iconColor="green"
      [clickable]="false"
      [matTooltip]="'completedJobsTooltip' | translate"
    ></app-ui-widget-card>
  </div>
</div>
